import styled from 'styled-components';

export const TableContainer = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.principal.ceres};
	border-radius: 6px;
	box-shadow: 0 1px 2px -2px rgba(20 15 51 /4%), 0 1px 4px 0 rgba(20 15 51 /8%);
	margin: 8px 0 34px;
	overflow-x: auto;
	width: 100%;
`;

export const Table = styled.table`
	border: none;
	border-collapse: collapse;
	margin: 0;
	width: 100%;
`;

export const TableHead = styled.thead`
	border-bottom: 1px solid ${({ theme }) => theme.colors.principal.ceres};
	margin: 0;
	width: 100px;
`;

export const TableHeader = styled.th`
	color: ${({ theme }) => theme.colors.extra.cygnus};
	font-size: 12px;
	font-weight: 400;
	line-height: 12px;
	padding: 16px 8px;
	text-align: start;
	white-space: nowrap;

	&:first-child {
		width: 400px; /* Establece un ancho fijo para la primera celda */
	}
`;

export const HeaderColumn = styled.div<SortByContainerProps>`
	cursor: ${({ allowSort }) => (allowSort ? 'pointer' : 'default')};
	display: flex;
	gap: 4px;

	&:hover {
		svg {
			opacity: ${({ allowSort }) => (allowSort ? '1' : '1')};
		}
	}
`;

interface SortByContainerProps {
	readonly allowSort?: boolean;
	readonly ordered?: boolean;
	readonly defaultSort?: boolean;
	readonly isActive?: boolean;
}

export const SortByContainer = styled.div<SortByContainerProps>`
	cursor: ${({ allowSort }) => (allowSort ? 'pointer' : 'default')};
	display: flex;
	height: 12px;
	position: relative;
	width: 12px;

	&:hover {
		svg {
			opacity: ${({ allowSort }) => (allowSort ? '1' : '0')};
		}
	}

	svg {
		opacity: ${({ defaultSort, isActive }) => (isActive || defaultSort ? '1' : '0.2')};
		transform: ${({ ordered }) => (ordered ? 'rotate(-180deg)' : 'rotate(0deg)')};
		transition: opacity, transform 0.2s ease-in-out;
	}
`;

interface ShowDatePickerContainerProps {
	y: 'top' | 'bottom';
	x: 'left' | 'right';
}

export const ShowPickerContainer = styled.div<ShowDatePickerContainerProps>`
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid #e6e6e6;
	border-radius: 8px;
	bottom: ${({ y }) => (y === 'top' ? '-100px' : 'inherit')};
	left: ${({ x }) => (x === 'left' ? '-50px' : 'inherit')};
	position: absolute;
	right: ${({ x }) => (x === 'right' ? '0' : 'inherit')};
	top: ${({ y }) => (y === 'bottom' ? '20px' : 'inherit')};
	z-index: 20;

	ul {
		display: flex;
		flex-direction: column;
		gap: 6px;
		width: 100%;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		bottom: inherit;
		max-width: 260px;
		padding: 10px;
		top: 20px;
	}
`;

interface SelectOptionProps {
	readonly isSelected: boolean;
}

export const SelectOption = styled.li<SelectOptionProps>`
	background-color: ${({ theme, isSelected }) => isSelected && theme.colors.principal.ceres};
	border-bottom: 1px solid rgba(255 255 255 / 20%);
	color: ${({ theme }) => theme.colors.principal.vanth};
	cursor: ${({ isSelected }) => (isSelected ? 'default' : 'pointer')};
	overflow: hidden;
	padding: 12px 15px;
	transition: transform 0.5s ease;

	&:first-child {
		border-bottom: none;
	}

	&:hover,
	&:focus {
		background-color: ${({ theme, isSelected }) => !isSelected && theme.colors.principal.ceres};

		&:first-of-type {
			border-radius: 8px 8px 0 0;
		}

		&:last-of-type {
			border-radius: 0 0 8px 8px;
		}
	}
`;

export const TableBody = styled.tbody`
	display: flex;
	flex-direction: column;
	height: 240px;
	justify-content: flex-start;
	overflow-y: auto;
	width: 100%;

	tr {
		border-bottom: 1px solid #e6e6e6;
		
		&:nth-of-type(odd) {
			background-color: ${({ theme }) => theme.colors.principal.air};
		}
	}
`;

export const TableRow = styled.tr`
	display: table;
	height: 58px;
	table-layout: fixed;
	width: 100%;
`;

export const TableData = styled.td`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 12px;
	line-height: 12px;
	overflow: hidden;
	padding: 8px;
	text-overflow: ellipsis;
	vertical-align: middle;
	white-space: nowrap;

	&:first-child {
		width: 400px;
	}
`;

export const TableUndefined = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.colors.principal.vanth};
	display: flex;
	font-size: 14px;
	height: 100%;
	justify-content: center;
	width: 100%;
`;
